<template>
  <div
    class="ckplayer"
    :style="
      'width:' + widthHeigt[0] + 'px;' + 'height:' + widthHeigt[1] + 'px;'
    "
  >
    <div  id="video"></div>
  </div>
</template>

<script>
export default {
  name: "ckplayerOne",
  components: {},
  props: {
    widthHeigt: {
      type: Array,
      default: () => {
        return [300, 100];
      }
    },
    videoUrl: {
      type: String,
      default: ''
    },
    isLive: {
      type: Boolean,
      default: {
        return: false
      }
    },
    ckplayerDialogShow: {
      type: Boolean,
      default: {
        return: false
      }
    }
  },
  data() {
    return {
      videoObject: {
        width: this.widthHeigt[0], // 宽度，也可以支持百分比(不过父元素宽度要有)
        height: this.widthHeigt[1], // 高度，也可以支持百分比
        container: "#video", //“#”代表容器的ID，“.”或“”代表容器的class
        variable: "player", //该属性必需设置，值等于下面的new chplayer()的对象
        // volume: 0, //音量，范围：0-1
        // loaded:'loadedHandler',
        autoplay: true, //自动播放
        flashplayer: false,
        html5m3u8: true, //PC平台上是否使用h5播放器播放m3u8
        live: this.isLive, //是否是直播
        unescape: false, //默认flashplayer里需要解码
        overspread: true, //是否让视频铺满播放器
        video: '', //视频地址(必填)
        controlBar:{
          hideControlBar:{
            hideEnvironment:'all'
          }
        }
      },
      player: {}
    };
  },
  created() {},
  watch: {
    index: function(newVal) {
      // console.log(newVal);
    },
    videoUrl: function(newVal,oldVal) {
      this.videoObject.video = newVal;
      this.play();
    },
    ckplayerDialogShow: function(newVal) {
      if(!newVal) {
        this.pause();
      }
    },
  },
  methods: {
    play() {
      let vm =this
       this.$Common.getPlayUrl(this.videoUrl).then(res=>{
        console.log(res)
        if(res.err){
            // this.$message.error(res.err)
        }else{
          vm.videoObject.video=res
          vm.player = new ckplayer(vm.videoObject);
        }
         

        }).catch(err=>{
          // this.$message.error(err)
        })
      // console.log(this.player);
    },
    pause() {
      this.player.videoPause();
    }
  },
  mounted() {
    this.play();
  }
};
</script>
<style lang="scss" scoped>
.ckplayer {
  // width: 500px;
  // height: 300px;
  .video {
    width: 100%;
    height: 100%;
  }
}
</style>
